import './App.css';
import AppContextProviders from './contexts';
import Routes from './routes';

export default () => {
  return (
    <AppContextProviders>
      <Routes />
    </AppContextProviders>
  );
};
